import React, { useState, useContext, useEffect, memo } from 'react'
import { Link } from 'react-router-dom'
import Favourite from '../Favourite_copy'
import { Image } from 'react-shimmer'
import './cards.css'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import moment from 'moment'
import { getTimeInterval } from '../../utils/commonFunctions'
import { useHistory } from 'react-router-dom'
import FavouriteCheckbox from '../../Product/components/atoms/FavoriteCheckbox'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import Timer from '../../Product/common/timer'
import Bidding from '../../Product/components/molecules/Bidding/BiddingItem'
import Facebook from '../../utils/CommonFunctionality/Share/Facebook'
import Whatsapp from '../../utils/CommonFunctionality/Share/Whatsapp'
import Twitter from '../../utils/CommonFunctionality/Share/Twitter'
import Email from '../../utils/CommonFunctionality/Share/Email'
import Pinterest from '../../utils/CommonFunctionality/Share/Pinterest'
import Copy from '../../utils/CommonFunctionality/Share/Copy'
import stateList from '../../utils/statelist'
import Biddingforwardandreverse from '../../Product/components/molecules/Bidding/biddingforwardandreverse'
import {
    currencyFormat,
    dateFormatFront,
    handleRedirectInternal,
    sellerNameFormat,
} from '../../Product/common/components'
import { Button, Tooltip, Popover, ClickAwayListener, Box } from '@material-ui/core'
import AddToCalendar from '../../Product/components/molecules/AddToCalendar'
import CartContext from '../../Product/context/cart/cartContext'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import { allCondition } from '../../utils'
import axios from 'axios'
import userContext from '../../Product/context/user/userContext'
import CurrencyConverterFormat from '../../utils/CommonFunctionality/CurrencyConverter/CurrencyConverterFormat'
import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'react-responsive'
import productContext from '../../Product/context/product/productContext'
import alertContext from '../../Product/context/alert/alertContext'
import Qtyinputcard from '../../Product/common/Qtyinputcard'
import { Rating } from '@material-ui/lab'
import buyerContext from '../../Product/context/buyer/buyerContext'
import SlidePanel from '../SlidePanel'
import ImageZoom from '../ImageZoom'
import { InfoOutlined, LocalShippingOutlined } from '@material-ui/icons'

const LotProduct = ({
    noTimer,
    noBuyNow,
    noBidButton,
    data,
    handleClick,
    searchCard,
    type,
    link,
    timerTheme,
    card_theme,
    cardTheme,
    additionalCardTheme,
    bidBtnLabel,
    getAllProducts,
    isRRThemeSlidePanel,
    lotImages,
    auction_and_buynow,
    lotBidding,
    flashCard,
    endingItem,
    currencyType,
    fromSearch,
    className,
    bidStatus,
    showCondition,
    showLocation,
    timerIcon,
    auctionTimer,
    viewProduct,
    setViewProduct,
    lotData,
    lotDetails,
    productViewLink,
    showEstimate,
    audio,
    removePopup,
    need_end_date,
    next_week_date,
    is_registered,
    // setAlert,
    private_auction,
    isMarineTheme,
    fromComponent,
    auction_city,
    hideQuickBid,
}) => {
    const history = useHistory()
    const addDefaultSrc = (e) => {
        e.target.src = `${global?.storeDetails?.logoValue}`
        e.target.className = `gridImage default`
    }
    const isTab = useMediaQuery({
        query: '(max-width: 768px)',
    })
    const authContext = useContext(AuthContext)
    const [showTooltip, setShowTooltip] = useState(false)
    const [bidModal, setBidModal] = useState(null)
    const cartContext = useContext(CartContext)
    const [selectedProduct, setSelectedProduct] = useState({})
    const { t } = useTranslation()
    const {
        addToCart,
        getUserCart,
        removeFromCart,
        responseStatus,
        buyer_cartitems,
        clearResponse,
    } = cartContext
    const { setAlert } = useContext(alertContext)
    const { productLocalState } = useContext(productContext)
    let { bidConfirm } = useContext(buyerContext)
    const { countryValues } = useContext(userContext)
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const { isAuthenticated, user } = authContext
    const [active, setActive] = useState(false)
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const [reload, setReload] = useState(false)
    const [reviewId, setReviewId] = useState('')
    const [bidText, setBidText] = useState('Bid Now')

    const handleClose = () => {
        setBidModal(null)
    }
    const showReview = (e) => {
        setReviewId('showReview')
    }
    useEffect(() => {
        if (buyer_cartitems.results) {
            if (data?.id) {
                let position = _.findIndex(buyer_cartitems.results, {
                    project_id: data.id,
                })
                position === -1 ? setActive(false) : setActive(true)
            }
        }
    }, [buyer_cartitems.results, data?.id])

    const result = Math.round(
        (currencyFormat(parseFloat(data?.wprice).toFixed(2), '%') /
            currencyFormat(parseFloat(data?.mprice).toFixed(2), '%')) *
            100,
    )

    useEffect(() => {
        const currencySplit = Math.round(data.wprice / data.mprice) * 100
        return currencySplit
    }, [data.wprice])

    const handleCart = async (id, qty) => {
        if (new Date(data.date_added) > new Date()) {
            return setAlert('Wait until auction starts!', 'warning')
        } else if (global?.storeConfigration?.guest_user_login?.value) {
            if (active) {
                removeFromCart({ id })
            } else
                addToCart({
                    id: data.id,
                    qty: qty ? qty : data.qty,
                    manufacture_date:
                        data.custom_field_9 && data.custom_field_9.includes('}')
                            ? JSON.parse(data.custom_field_9)?.inventory_date
                            : '',
                })
        } else {
            if (!user?.card_paymentid) {
                setAlert('Add a card to buy!', 'error')
                return handleRedirectInternal(history, 'dashboard/cards')
            }
            if (active) {
                removeFromCart({ id })
            } else
                addToCart({
                    id: data.id,
                    qty: qty ? qty : data.qty,
                    manufacture_date:
                        data.custom_field_9 && data.custom_field_9.includes('}')
                            ? JSON.parse(data.custom_field_9)?.inventory_date
                            : '',
                })
        }
    }

    const categoryTypes = {}
    global.allCategories.map((catgeory) => (categoryTypes[catgeory.id] = catgeory))

    // useEffect(() => {
    //     if (responseStatus) {
    //         if (responseStatus.from === 'addToCart') {
    //             if (responseStatus.status === 'success') {
    //                 console.log('++++++++++++')
    //                 getUserCart()
    //                 clearResponse()
    //             }
    //         } else if (responseStatus.from === 'removeFromCart') {
    //             if (responseStatus.status === 'success') {
    //                 getUserCart()
    //                 clearResponse()
    //             }
    //         }
    //     }
    // }, [responseStatus])

    useEffect(() => {
        if (data?.extra_fields?.includes('}')) {
            let parse = JSON.parse(data.extra_fields)
            Object.keys(parse).map((val) => {
                data[val] = parse[val]
            })
        }
    }, [data?.extra_fields])
    const getBidText = (data) => {
        if (
            isAuthenticated &&
            (data.latestbid_user != null || data.highest_bidder_user_id != null) &&
            user?.id != undefined
        ) {
            if (data.auction) {
                if (
                    (data.latestbid_user == user?.id || data.highest_bidder_user_id == user?.id) &&
                    data.wprice >= data.rprice
                ) {
                    if (data.market_status == 'open') {
                        setBidText('Winning')
                    } else if (data.market_status == 'sold') {
                        setBidText('Won')
                    }
                } else if (
                    (data.latestbid_user != user?.id || data.highest_bidder_user_id != user?.id) &&
                    (data.currentUserBidAmount || data.bid_or_not || data.cbidnot || data.mybid)
                ) {
                    if (data.market_status == 'open') {
                        setBidText('Outbid')
                    } else if (data.market_status == 'sold') {
                        setBidText('Lost')
                    }
                } else {
                    setBidText('Bid Now')
                }
            }
        } else {
            setBidText('Bid Now')
        }
    }

    useEffect(() => {
        getBidText(data)
    }, [data.wprice, user?.id, isAuthenticated])

    const [countryList, setCountryList] = useState([])

    const isArtTheme = document.querySelector('body').classList.contains('artTheme')
    const isHyperMicroTheme = document.querySelector('body').classList.contains('hyperMicro')

    const getLocationData = () => {
        var body = {
            countryCode: 38,
        }

        return axios
            .post(`${process.env.REACT_APP_URL}fetchLocation`, body)
            .then(function (response) {
                if (response.data.success) {
                    setCountryList([
                        response.data.country.find((value) => parseInt(value.location_id) === 224),
                        ...response.data.country.filter(
                            (value) => parseInt(value.location_id) !== 224,
                        ),
                    ])
                }
            })
            .catch(function (error) {
                // console.log(error)
            })
    }

    useEffect(() => {
        // getLocationData()
        getBidText(data)
    }, [data])

    // share icons funa

    const [shareAnchorEl, setShareAnchorEl] = useState(null)

    const handleShareClick = (event) => {
        setShareAnchorEl(event.currentTarget)
    }

    const handleShareClose = () => {
        setShareAnchorEl(null)
    }

    const handleBidModalClick = (id) => {
        setBidModal(id)
    }

    const openshare = Boolean(shareAnchorEl)
    const id = open ? 'simple-popover' : undefined

    const handleProductClick = (URL) => {
        console.warn('awrn')
        history.push({
            pathname: URL,
        })
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    const hanlderedirection = (id) => {
        if (parseInt(is_registered) == 0 && parseInt(private_auction) == 1) {
            setAlert('Please register auction and continue!', 'error')
        } else {
            history.push({
                pathname: `/productView/${id}`,
                state: { lotid: lotDetails },
            })
        }
    }

    const bidsubmit = (data) => {
        bidConfirm({
            auction_io: 1,
            bid_increment: data.incrementamt,
            email: user?.email,
            first_name: user?.first_name,
            hard_bid: '1',
            id: data.id,
            last_name: user?.last_name,
            wsprice: data.next_bid,
        })
    }

    const [tipOpen, setTipOpen] = React.useState(false)
    const handlehoverTioClose = () => {
        setTipOpen(false)
    }

    const handlehoverTioOpen = () => {
        setTipOpen(true)
    }

    const isTouchDevice = () => {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0
    }

    const getDiscountPercentage = (retailPrice, buyNowPrice) => {
        if (!retailPrice || retailPrice <= 0) return 0
        const discount = ((retailPrice - buyNowPrice) / retailPrice) * 100
        return discount.toFixed(0)
    }
    function getStateAbbreviation(fullStateName) {
        const match = stateList.find(
            (item) => item.name.toLowerCase() === fullStateName?.toLowerCase(),
        )
        return match ? match.value : fullStateName
    }
    const isLOAProject = document.querySelector('body').classList.contains('LotsAuction')
    const isRRProject = global.storeConfigration?.bodyClass?.value === 'greenField'

    const discount = getDiscountPercentage(data.mprice, data.bprice)
    const wdiscount = getDiscountPercentage(data.mprice, data.wprice)
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    return (
        <div
            className={`card grid-card gallery ${
                fromComponent == 'home' ? '' : 'fromSearch'
            } ${className} 
            ${bidText === 'Winning' && 'winningcard'} 
            ${bidText === 'Outbid' && 'losingcard'} `}
        >
            {!isBargainsProject && (
                <>{data?.feature == 1 && !endingItem && <div className="ribbon">Flash Deal</div>}</>
            )}
            {/* {flashCard && <div className="ribbon">Flash Deal</div>} */}
            {!noBidButton && link && fromComponent != 'home' && (
                <>
                    {data.id !== undefined ? (
                        <></>
                    ) : (
                        type !== 'buynow' && (
                            <Link
                                className={`${'pink-btn pbtn-sm'} ${
                                    isAuthenticated &&
                                    data.auction != 0 &&
                                    bidText == 'Winning' &&
                                    'winBtnWrpr'
                                } ${
                                    isAuthenticated &&
                                    data.auction != 0 &&
                                    bidText == 'Outbid' &&
                                    'outbidBtnWrpr'
                                }`}
                                to={link}
                                params={{ product_id: data.id }}
                            >
                                {window.location.pathname.includes('search') ||
                                type === 'Auction' ||
                                data.auction
                                    ? type === 'buynow'
                                        ? isAuthenticated
                                            ? 'Buy Now'
                                            : 'Login To Buy Now'
                                        : isAuthenticated
                                        ? bidText
                                        : 'Login To Bid'
                                    : isAuthenticated
                                    ? 'Buy Now'
                                    : 'Login To Buy Now'}{' '}
                                <i className="fa fa-long-arrow-alt-right"></i>
                            </Link>
                        )
                    )}
                </>
            )}
            {/* {isRRProject &&
                isAuthenticated &&
                (bidText == 'Winning' ||
                    bidText == 'Won' ||
                    bidText == 'Outbid' ||
                    bidText == 'Lost') && (
                    <div
                        className={`${isAuthenticated && 'gridItemAct bid-now-wrap'} ${
                            isAuthenticated &&
                            (bidText == 'Winning' || bidText == 'Won') &&
                            'winBtnWrpr'
                        } ${
                            isAuthenticated &&
                            (bidText == 'Outbid' || bidText == 'Lost') &&
                            'outbidBtnWrpr'
                        }`}
                    >
                        <PrimaryButton
                            disabled={data.market_status == 'sold'}
                            name={data.id}
                            label={bidText}
                            btnColor={data.latestbid_user == user?.id && 'success'}
                        />
                    </div>
                )} */}
            <div className="grid-img-wrap">
                {isRRProject && card_theme == 'lotsauction' ? null : (
                    <>
                        {auction_city || data.auction_city ? (
                            <div className="grid-loc">
                                <img src="/lots-images/loc.svg" alt="" />
                                {auction_city || data.auction_city},{' '}
                                {getStateAbbreviation(data.auction_state)}
                            </div>
                        ) : (
                            ''
                        )}
                    </>
                )}
                {isBuyBestProject && (
                    <>
                        {auction_city || data.auction_city ? (
                            <div className="grid-loc">
                                <span className="material-icons">location_on</span>
                                {auction_city || data.auction_city},{' '}
                                {getStateAbbreviation(data.auction_state)}
                            </div>
                        ) : (
                            ''
                        )}
                    </>
                )}
                {isRRProject &&
                    isAuthenticated &&
                    (bidText == 'Winning' ||
                        bidText == 'Won' ||
                        bidText == 'Outbid' ||
                        bidText == 'Lost') && (
                        <div
                            className={`${isAuthenticated && 'gridItemAct bid-now-wrap'} ${
                                isAuthenticated &&
                                (bidText == 'Winning' || bidText == 'Won') &&
                                'winBtnWrpr'
                            } ${
                                isAuthenticated &&
                                (bidText == 'Outbid' || bidText == 'Lost') &&
                                'outbidBtnWrpr'
                            }`}
                        >
                            <PrimaryButton
                                disabled={data.market_status == 'sold'}
                                name={data.id}
                                label={bidText}
                                btnColor={data.latestbid_user == user?.id && 'success'}
                            />
                        </div>
                    )}
                {global?.storeConfigration?.sold_status?.value == '1' ? (
                    <></>
                ) : (
                    <>
                        {data.market_status === 'sold' && (
                            <div className="soldWrapper">
                                <p>SOLD</p>
                            </div>
                        )}
                        {data.market_status === 'closed' && (
                            <div className="soldWrapper">
                                <p>UNSOLD</p>
                            </div>
                        )}
                    </>
                )}
                {isBuyBestProject ? (
                    <ImageZoom
                        src={`${
                            data.content_head1 === '0' || data.store_id === 0
                                ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                : process.env.REACT_APP_PRODUCT_IMAGE_URL
                        }${
                            global.storeConfigration?.image_compression?.value == 1 ? 'thumb_' : ''
                        }${
                            (lotImages?.length && lotImages[0]?.file_name) ||
                            (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                            data.file_name ||
                            data.avatar_vc
                        }`}
                    >
                        <LazyLoadImage
                            src={`${
                                data.content_head1 === '0' || data.store_id === 0
                                    ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                    : process.env.REACT_APP_PRODUCT_IMAGE_URL
                            }${
                                global.storeConfigration?.image_compression?.value == 1
                                    ? 'thumb_'
                                    : ''
                            }${
                                (lotImages?.length && lotImages[0]?.file_name) ||
                                (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                                data.file_name ||
                                data.avatar_vc
                            }`}
                            effect="blur"
                            placeholderSrc="/assets/svg/imageLoading.svg"
                            height="100%"
                            width="100%"
                            threshold={1}
                            className="gridImage"
                            onError={addDefaultSrc}
                            loading="lazy"
                            decoding="async"
                            alt={data.title}
                            onClick={() =>
                                productViewLink
                                    ? handleProductClick(productViewLink)
                                    : global.storeDetails?.theme === 9
                                    ? hanlderedirection(data.id)
                                    : cardTheme === 'carAuction'
                                    ? history.push({
                                          pathname: `/productView/${data.id}`,
                                          state: { lotid: lotDetails },
                                      })
                                    : handleClick(data.id)
                            }
                        />
                    </ImageZoom>
                ) : (
                    <LazyLoadImage
                        src={`${
                            data.content_head1 === '0' || data.store_id === 0
                                ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                : process.env.REACT_APP_PRODUCT_IMAGE_URL
                        }${
                            global.storeConfigration?.image_compression?.value == 1 ? 'thumb_' : ''
                        }${
                            (lotImages?.length && lotImages[0]?.file_name) ||
                            (data?.lotImages?.length && data?.lotImages[0]?.file_name) ||
                            data.file_name ||
                            data.avatar_vc
                        }`}
                        effect="blur"
                        placeholderSrc="/assets/svg/imageLoading.svg"
                        height="100%"
                        threshold={1}
                        width="100%"
                        className="gridImage"
                        //onClick={() => handleClick(data.id)}
                        onError={addDefaultSrc}
                        loading="lazy"
                        decoding="async"
                        alt={data.title}
                        onClick={() =>
                            productViewLink
                                ? handleProductClick(productViewLink)
                                : global.storeDetails?.theme === 9
                                ? hanlderedirection(data.id)
                                : cardTheme === 'carAuction'
                                ? history.push({
                                      pathname: `/productView/${data.id}`,
                                      state: { lotid: lotDetails },
                                  })
                                : handleClick(data.id)
                        }
                    />
                )}
                <FavouriteCheckbox
                    watchlisted={data.watchlistid || data.watchlisted || data.isFav}
                    project_id={data.id}
                    from="card"
                    getAllProducts={getAllProducts}
                    viewProduct={viewProduct}
                    setViewProduct={setViewProduct}
                    theme={cardTheme}
                    data={data}
                />
                {global.pluginConfiguration?.most_viewed?.enable == 1 && data.viewers ? (
                    <p className="viewsCountValue">Viewers: {data.viewers}</p>
                ) : null}
            </div>
            <div className={`${endingItem ? 'card-body endingItem' : 'card-body'}`}>
                <>
                    {data.title !== undefined && (
                        <>
                            {isRRProject ? null : (
                                <>
                                    {global?.storeConfigration?.lot_sequence_order?.value == 1 ? (
                                        <p className="gpAddnInfo">
                                            Lot #: <span>{data?.deed_document || '-'}</span>
                                        </p>
                                    ) : (
                                        <p className="gpAddnInfo">
                                            Lot Number:{' '}
                                            <span>
                                                {data?.lot_number !== '' ? data?.lot_number : '-'}
                                            </span>
                                        </p>
                                    )}
                                </>
                            )}
                            {isRRProject && !isBuyBestProject && (
                                <>
                                    {searchCard ? (
                                        <>
                                            <div className="cardCount">
                                                {isVarifiedGfTheme &&
                                                parseInt(data?.auction) == 1 ? (
                                                    <>{data?.nobids} Bids | </>
                                                ) : null}
                                                {data?.watchlist_count !== '' &&
                                                data?.watchlist_count !== null
                                                    ? data?.watchlist_count
                                                    : 0}{' '}
                                                Watchers | {data?.most_viewed || 25} Viewers
                                            </div>
                                            {data.market_status === 'open' && data.auction == 1 ? (
                                                <Timer
                                                    date_added={data.date_added}
                                                    date_closed={data.date_closed}
                                                    withText={1}
                                                    endText={' '}
                                                    startText={' '}
                                                    theme="gFThemeTimer"
                                                    iconGrid={false}
                                                    audio={audio}
                                                />
                                            ) : (
                                                <>
                                                    {data.buynow === 0 ? (
                                                        <div className="closedText text-center d-block minHeight">
                                                            Auction Closed
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={`closedText text-center d-block ${
                                                                isVarifiedGfTheme
                                                                    ? 'cardTimerRetail'
                                                                    : ''
                                                            } `}
                                                        ></div>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <div className="cardCount">
                                                {isVarifiedGfTheme &&
                                                parseInt(data?.auction) == 1 ? (
                                                    <>{data?.nobids} Bids | </>
                                                ) : null}
                                                {data?.watchlist_count !== '' &&
                                                data?.watchlist_count !== null
                                                    ? data?.watchlist_count
                                                    : 0}{' '}
                                                Watchers | {data?.most_viewed} Viewers
                                            </div>
                                            <div
                                                className={`
                                                    ${isVarifiedGfTheme ? 'cardTimerRetail' : ''} 
                                                    ${data.buynow == 1 && 'buyNowCadd'}`}
                                            >
                                                {data.market_status === 'open' && data.auction ? (
                                                    <Timer
                                                        date_added={data.date_added}
                                                        date_closed={data.date_closed}
                                                        withText={1}
                                                        endText={' '}
                                                        startText={' '}
                                                        theme="gFThemeTimer"
                                                        iconGrid={false}
                                                        audio={audio}
                                                    />
                                                ) : (
                                                    <>
                                                        {data.buynow === 0 ? (
                                                            <div className="closedText text-center d-block minHeight">
                                                                Auction Closed
                                                            </div>
                                                        ) : (
                                                            <div className="closedText text-center d-block"></div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            <h5
                                className="name-txt cursorDecoy"
                                onClick={() =>
                                    cardTheme === 'carAuction'
                                        ? history.push({
                                              pathname: `/productView/${data.id}`,
                                              state: { lotid: lotDetails },
                                          })
                                        : productViewLink
                                        ? history.push({
                                              pathname: productViewLink,
                                          })
                                        : handleClick(data.id)
                                }
                                dangerouslySetInnerHTML={{
                                    __html:
                                        cardTheme == 'auctioneer' &&
                                        data.category_id !=
                                            global?.storeConfigration?.similar_category?.value
                                            ? `${
                                                  data.custom_field_9 &&
                                                  data.custom_field_9.includes('}')
                                                      ? JSON.parse(data.custom_field_9)?.game_theme
                                                      : ''
                                              } ${data.subcategory
                                                  ?.split(',')
                                                  ?.map(
                                                      (val) =>
                                                          categoryTypes[val]?.description ?? '',
                                                  )
                                                  ?.join(', ')}`
                                            : data.title,
                                }}
                            />
                            {isBuyBestProject && (
                                <>
                                    {fromComponent === 'home' ? (
                                        <>
                                            {global?.storeConfigration?.remove_rating?.value !=
                                            1 ? (
                                                <div className="ratingLiqThree">
                                                    <div
                                                        className="gvRating"
                                                        onClick={() => {
                                                            showReview()
                                                        }}
                                                    >
                                                        <Rating
                                                            name="read-only"
                                                            value={
                                                                data?.auctionnotes
                                                                    ?.trim()
                                                                    .toLowerCase()
                                                                    .includes('new')
                                                                    ? 5
                                                                    : data?.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('open')
                                                                    ? 4.5
                                                                    : data?.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('damage')
                                                                    ? 3.5
                                                                    : 2.5
                                                            }
                                                            precision={0.5}
                                                            readOnly
                                                        />
                                                    </div>

                                                    {reviewId ? (
                                                        <>
                                                            <div className="fiveStar"></div>
                                                            <p className="fiveStarText">
                                                                {data?.auctionnotes
                                                                    ?.trim()
                                                                    .toLowerCase()
                                                                    .includes('new')
                                                                    ? "These items are rated 5 stars and are brand new. They represent the pinnacle of quality, with no flaws or imperfections. Purchase with absolute confidence, knowing you're receiving the highest standard of excellence."
                                                                    : data.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('open')
                                                                    ? "These items are rated 4.5 stars and are in open box condition. While they have been opened, they are still in excellent condition with minimal signs of use. Rest assured, you're getting high-quality content with just a touch of prior handling."
                                                                    : data.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('damage')
                                                                    ? "These Items are rated 3.5 stars and are in damaged condition. While it may not meet retail standards, it's not in such poor condition that it's only suitable for parts. This item might have been used or could be missing its packaging."
                                                                    : "These Items are rated 2.5 stars and with additional imperfections, please consult the accompanying notes for detailed insights into their condition. Our aim is to provide transparency, ensuring you're fully informed before making a decision."}
                                                            </p>
                                                            <div className="">
                                                                <PrimaryButton
                                                                    label={'OK'}
                                                                    onClick={() => {
                                                                        setReviewId('')
                                                                    }}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : null}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    ) : (
                                        <div className="gvRatingDetails">
                                            {global?.storeConfigration?.remove_rating?.value !=
                                            1 ? (
                                                <div className={'ratingLiqThree' + ' ' + reviewId}>
                                                    <div
                                                        className="gvRating"
                                                        onClick={() => {
                                                            showReview()
                                                        }}
                                                    >
                                                        <Rating
                                                            name="read-only"
                                                            value={
                                                                data?.auctionnotes
                                                                    ?.trim()
                                                                    .toLowerCase()
                                                                    .includes('new')
                                                                    ? 5
                                                                    : data?.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('open')
                                                                    ? 4.5
                                                                    : data?.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('damage')
                                                                    ? 3.5
                                                                    : 2.5
                                                            }
                                                            precision={0.5}
                                                            readOnly
                                                        />
                                                    </div>

                                                    {reviewId ? (
                                                        <>
                                                            <div className="fiveStar"></div>
                                                            <p className="fiveStarText">
                                                                {data?.auctionnotes
                                                                    ?.trim()
                                                                    .toLowerCase()
                                                                    .includes('new')
                                                                    ? "These items are rated 5 stars and are brand new. They represent the pinnacle of quality, with no flaws or imperfections. Purchase with absolute confidence, knowing you're receiving the highest standard of excellence."
                                                                    : data.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('open')
                                                                    ? "These items are rated 4.5 stars and are in open box condition. While they have been opened, they are still in excellent condition with minimal signs of use. Rest assured, you're getting high-quality content with just a touch of prior handling."
                                                                    : data.auctionnotes
                                                                          ?.trim()
                                                                          .toLowerCase()
                                                                          .includes('damage')
                                                                    ? "These Items are rated 3.5 stars and are in damaged condition. While it may not meet retail standards, it's not in such poor condition that it's only suitable for parts. This item might have been used or could be missing its packaging."
                                                                    : "These Items are rated 2.5 stars and with additional imperfections, please consult the accompanying notes for detailed insights into their condition. Our aim is to provide transparency, ensuring you're fully informed before making a decision."}
                                                            </p>
                                                            <div className="">
                                                                <PrimaryButton
                                                                    label={'OK'}
                                                                    onClick={() => {
                                                                        setReviewId('')
                                                                    }}
                                                                />
                                                            </div>
                                                        </>
                                                    ) : null}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                            <h6 className="galleryPrice condition">
                                                <span className="ratingDot"></span>
                                                <span>Condition:</span>
                                                <span
                                                    className={`prcTxtVal`}
                                                    title={
                                                        data.auctionnotes ? data.auctionnotes : '-'
                                                    }
                                                >
                                                    {data.auctionnotes ? data.auctionnotes : '-'}
                                                </span>
                                            </h6>
                                        </div>
                                    )}
                                    <div className="gvPriceInfo d-flex justify-content-between">
                                        <div className="gridBidInfo">
                                            <div className="prcCntnr">
                                                <span>
                                                    {currencyFormat(
                                                        parseFloat(
                                                            data.auction && data.wprice
                                                                ? data.wprice
                                                                : data.bprice,
                                                        ).toFixed(2),
                                                        currencyType,
                                                    )}
                                                    {/* <CurrencyConverterFormat amount={data.bprice} /> */}
                                                </span>
                                                <label>
                                                    {data.market_status === 'sold'
                                                        ? 'Sold'
                                                        : data.auction && data.wprice
                                                        ? data.nobids > 0
                                                            ? 'Current Price'
                                                            : 'Start Price'
                                                        : 'Buy Now'}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="retailPickup">
                                            {fromComponent === 'home' ? (
                                                <Tooltip
                                                    title={
                                                        <h6 className="galleryPrice condition">
                                                            <span className="mb-2">Condition:</span>
                                                            <br />
                                                            <span
                                                                className={`prcTxtVal`}
                                                                title={
                                                                    data.auctionnotes
                                                                        ? data.auctionnotes
                                                                        : '-'
                                                                }
                                                            >
                                                                {data.auctionnotes
                                                                    ? data.auctionnotes
                                                                    : '-'}
                                                            </span>
                                                        </h6>
                                                    }
                                                >
                                                    <p className="lotInsights d-flex align-items-center">
                                                        <InfoOutlined /> See Lot Insights
                                                    </p>
                                                </Tooltip>
                                            ) : (
                                                <div className="pickUpOnly fromSearchPickuP">
                                                    Retail{' '}
                                                    {currencyFormat(
                                                        parseFloat(data.mprice || 0).toFixed(2),
                                                        currencyType,
                                                    )}
                                                    <CurrencyConverterFormat amount={data.mprice} />
                                                </div>
                                            )}
                                            <p className="pickOnly d-flex align-items-center">
                                                <LocalShippingOutlined /> Pick up only
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center endPart">
                                        {!data.buynow || data.auction ? (
                                            <span
                                                className="bidsCount"
                                                // onClick={(e) => {
                                                //     handleBidHistoryModal(data)
                                                // }}
                                            >
                                                {data.nobids || data.bid_count || 0} Bids
                                            </span>
                                        ) : null}
                                        <Tooltip
                                            title={
                                                data.auction == 1 &&
                                                type != 'buynow' && (
                                                    <div className="text-center endDteTxt">
                                                        {data.market_status === 'open' ? (
                                                            <>
                                                                {cardTheme == 'liquidationTwo' ? (
                                                                    <p className="mb-0">
                                                                        Ends{' '}
                                                                        {`${moment(data.date_closed)
                                                                            .tz(
                                                                                global
                                                                                    ?.storeConfigration
                                                                                    ?.auction_view_time_zone
                                                                                    ?.value
                                                                                    ? global
                                                                                          ?.storeConfigration
                                                                                          ?.auction_view_time_zone
                                                                                          ?.value
                                                                                    : moment.tz.guess(),
                                                                            )
                                                                            .format(
                                                                                'MMM Do',
                                                                            )}, ${moment(
                                                                            data.date_closed,
                                                                        )
                                                                            .tz(
                                                                                global
                                                                                    ?.storeConfigration
                                                                                    ?.auction_view_time_zone
                                                                                    ?.value
                                                                                    ? global
                                                                                          ?.storeConfigration
                                                                                          ?.auction_view_time_zone
                                                                                          ?.value
                                                                                    : moment.tz.guess(),
                                                                            )
                                                                            .format('h:mm a')}`}
                                                                    </p>
                                                                ) : (
                                                                    <p className="mb-0">
                                                                        Ends{' '}
                                                                        {dateFormatFront(
                                                                            data.date_closed,
                                                                        )}
                                                                    </p>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <p className="mb-0">Auction Closed</p>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        >
                                            {!noTimer && data.date_closed && (
                                                <div
                                                    className={`gcTimer primeTmCrd ${reviewId} hoTimer ${
                                                        data.buynow === 1 && data.auction === 0
                                                            ? 'noBackDrop'
                                                            : ''
                                                    }`}
                                                >
                                                    {(data.market_status === 'open' &&
                                                        data.auction) ||
                                                    (data.market_status === 'open' &&
                                                        auction_and_buynow) ? (
                                                        <Timer
                                                            date_added={data.date_added}
                                                            date_closed={data.date_closed}
                                                            withText={1}
                                                            endText={'Ends in' + ': '}
                                                            startText={'Starts in' + ': '}
                                                            theme={timerTheme}
                                                            // icon={timerIcon}
                                                            audio={audio}
                                                            product_id={data.id}
                                                            viewProduct={viewProduct}
                                                            setViewProduct={setViewProduct}
                                                        />
                                                    ) : (
                                                        <>
                                                            {data.buynow === 0 ? (
                                                                <span className="closedText">
                                                                    Auction Closed
                                                                </span>
                                                            ) : (
                                                                <div className="closedText"></div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </Tooltip>
                                    </div>
                                </>
                            )}
                            {isRRProject && card_theme == 'lotsauction' ? null : (
                                <div className="ratingLiqThree d-flex justify-content-between">
                                    {/* Condition :{' '} */}
                                    <div className="d-flex justify-content-between w-100 flex-wrap">
                                        <div className="d-flex justify-content-start align-items-start w-100 flex-wrap loaCategory">
                                            {data.auctionnotes.length
                                                ? data.auctionnotes != (null || undefined) &&
                                                  data.auctionnotes
                                                      ?.split(',')
                                                      ?.map((val, index) => (
                                                          <div
                                                              className="conditionLiq loa-condition"
                                                              key={index}
                                                          >
                                                              <p className="m-0 cursorDecoy">
                                                                  {val}
                                                              </p>
                                                          </div>
                                                      ))
                                                : null}
                                        </div>

                                        <div className="glot-id">
                                            {' '}
                                            {fromSearch ||
                                            global.storeConfigration?.own_seller?.value == '1' ? (
                                                <h6>
                                                    {global.storeDetails.theme == 19 ? (
                                                        <>Lot #{data.lot_number}</>
                                                    ) : (
                                                        <>Lot ID# {data.category_id}</>
                                                    )}
                                                </h6>
                                            ) : (
                                                <h6>Auction ID# {data.lotof}</h6>
                                            )}
                                        </div>
                                    </div>
                                    {/* <Rating
                                    name="read-only"
                                    value={
                                        global.storeDetails.theme == 19
                                            ? data.auctionnotes
                                                  .trim()
                                                  .toLowerCase()
                                                  .includes('rating 5')
                                                ? 5
                                                : data.auctionnotes
                                                      .trim()
                                                      .toLowerCase()
                                                      .includes('rating 4')
                                                ? 4
                                                : data.auctionnotes
                                                      .trim()
                                                      .toLowerCase()
                                                      .includes('rating 3')
                                                ? 3
                                                : data.auctionnotes
                                                      .trim()
                                                      .toLowerCase()
                                                      .includes('rating 2')
                                                ? 2
                                                : 1
                                            : 5
                                    }
                                    precision={0.5}
                                    readOnly
                                /> */}
                                </div>
                            )}
                            {!isBuyBestProject && (
                                <>
                                    {data?.conditionunique &&
                                    data?.conditionunique &&
                                    global.storeDetails.theme !== 19 ? (
                                        <div className="conditionLiq loa-condition">
                                            <p className="m-0 cursorDecoy">
                                                {data?.conditionunique}
                                            </p>
                                        </div>
                                    ) : null}
                                </>
                            )}
                            {cardTheme == 'auctioneer' && (
                                <>
                                    {global.storeConfigration?.disable_hosted_by?.value != 1 ? (
                                        <h5 className="ref-text">
                                            {data.title} Refurbished{' '}
                                            {data.subcategory
                                                ?.split(',')
                                                ?.map(
                                                    (val) => categoryTypes[val]?.description ?? '',
                                                )
                                                ?.join(', ')}{' '}
                                            Machine
                                        </h5>
                                    ) : null}
                                </>
                            )}
                            {showEstimate === true &&
                                (parseInt(data.lowest) > 0 || parseInt(data.highest) > 0) && (
                                    <p>
                                        Est:{' '}
                                        <span>
                                            {currencyFormat(data.lowest)} -{' '}
                                            {currencyFormat(data.highest)}
                                        </span>
                                    </p>
                                )}
                            {cardTheme !== 'liquidationTwo' && (
                                <>
                                    {global.storeConfigration?.enable_city?.value == 1 &&
                                    data.product_city ? (
                                        <h5 className="hostedBy">{data.product_city}</h5>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            )}
                            {cardTheme === 'liquidationTwo' &&
                            (global.storeConfigration?.condition_field?.value == 1 ||
                                global.storeConfigration?.damaged_field?.value == 1 ||
                                global.storeConfigration?.functional_field?.value == 1 ||
                                global.storeConfigration?.missing_parts_field?.value == 1) ? (
                                <div className="pdtStsInfo">
                                    <ul>
                                        <li>
                                            <label>Condition:</label>
                                            <Tooltip
                                                title={data.condition_field || '-'}
                                                arrow
                                                placement="top"
                                            >
                                                <p
                                                    className={`m-0 cursorDecoy ${
                                                        data.condition_field?.includes(
                                                            'Used - Like New',
                                                        )
                                                            ? 'text-primary'
                                                            : data.condition_field?.includes('New')
                                                            ? 'text-success'
                                                            : 'text-danger'
                                                    }`}
                                                >
                                                    {data.condition_field || '-'}
                                                </p>
                                            </Tooltip>
                                        </li>

                                        <li>
                                            <label>Functional:</label>
                                            <p
                                                className={`m-0 ${
                                                    data.functional_field?.includes('Yes')
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                }`}
                                            >
                                                {data.functional_field || '-'}
                                            </p>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <label>Damaged:</label>
                                            <p
                                                className={`m-0 ${
                                                    data.damaged_field?.includes('No')
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                }`}
                                            >
                                                {data.damaged_field || '-'}
                                            </p>
                                        </li>

                                        <li>
                                            <label>Missing Parts:</label>
                                            <p
                                                className={`m-0 ${
                                                    data.missing_parts_field?.includes('Yes')
                                                        ? 'text-danger'
                                                        : 'text-success'
                                                }`}
                                            >
                                                {data.missing_parts_field || '-'}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            ) : null}
                            {showCondition ? (
                                <p className="gpAddnInfo">
                                    Condition:{' '}
                                    {cardTheme == 'auctioneer' ? (
                                        <span
                                            className={`${
                                                data.auctionnotes
                                                    ?.trim()
                                                    ?.toLowerCase()
                                                    ?.includes('new')
                                                    ? 'text-success'
                                                    : data.auctionnotes
                                                          ?.trim()
                                                          ?.toLowerCase()
                                                          ?.includes('open box')
                                                    ? 'text-primary'
                                                    : data.auctionnotes
                                                          ?.trim()
                                                          ?.toLowerCase()
                                                          ?.includes('damage')
                                                    ? 'text-danger'
                                                    : ''
                                            }`}
                                        >
                                            {data?.auctionnotes}
                                        </span>
                                    ) : (
                                        <span>
                                            {data?.conditionunique
                                                ? allCondition
                                                      .filter(
                                                          (condition) =>
                                                              condition.id == data.conditionunique,
                                                      )
                                                      .map((d) => d.description)
                                                : '--'}
                                        </span>
                                    )}
                                </p>
                            ) : (
                                ''
                            )}
                            {!isBuyBestProject && (
                                <>
                                    {global.storeDetails?.theme === 19 && data.auctionnotes && (
                                        <>
                                            <ClickAwayListener onClickAway={handlehoverTioClose}>
                                                <Tooltip
                                                    open={tipOpen}
                                                    onClose={handlehoverTioClose}
                                                    onOpen={() =>
                                                        !isTouchDevice() && setTipOpen(true)
                                                    }
                                                    disableFocusListener={isTouchDevice()}
                                                    disableHoverListener={isTouchDevice()}
                                                    disableTouchListener
                                                    placement="bottom-start"
                                                    onClick={
                                                        isTouchDevice()
                                                            ? handlehoverTioOpen
                                                            : undefined
                                                    }
                                                    title={
                                                        <Box
                                                            sx={{ p: 1 }}
                                                            className="tooltipBox greenToolTip"
                                                        >
                                                            {data.auctionnotes === 'New' ? (
                                                                <p>
                                                                    Brand new, unopened, and unused
                                                                    in its original packaging.
                                                                </p>
                                                            ) : data.auctionnotes === 'Used' ? (
                                                                <p>
                                                                    The product has noticeable signs
                                                                    of use or damage.
                                                                </p>
                                                            ) : data.auctionnotes === 'Damaged' ? (
                                                                <p>
                                                                    Item has visible damage and may
                                                                    be non-functional. Sold AS-IS
                                                                    with no guarantees.
                                                                </p>
                                                            ) : data.auctionnotes === 'test' ||
                                                              data.auctionnotes === 'Test' ? (
                                                                <p>
                                                                    Item was tested and its
                                                                    functionality is partially or
                                                                    fully confirmed.
                                                                </p>
                                                            ) : data.auctionnotes === 'Open-box' ||
                                                              data.auctionnotes === 'Open-Box' ||
                                                              data.auctionnotes === 'Open Box' ? (
                                                                <p>
                                                                    The product has been opened but
                                                                    shows no obvious signs of use.
                                                                    Packaging may vary.
                                                                </p>
                                                            ) : data.auctionnotes === 'Like new' ||
                                                              data.auctionnotes === 'Like New' ? (
                                                                <p>
                                                                    The product is in perfect
                                                                    condition, as if brand new, and
                                                                    is factory sealed.
                                                                </p>
                                                            ) : data.auctionnotes ===
                                                                  'Not Inspected' ||
                                                              data.auctionnotes ===
                                                                  'Uninspected' ? (
                                                                <p>
                                                                    The product hasn&apos;t been
                                                                    checked for condition or working
                                                                    status.
                                                                </p>
                                                            ) : data.auctionnotes === 'Untested' ? (
                                                                <p>
                                                                    The item functionality has not
                                                                    been verified. Condition unknown
                                                                    and sold AS-IS.
                                                                </p>
                                                            ) : (
                                                                <p>{data.auctionnotes}</p>
                                                            )}
                                                        </Box>
                                                    }
                                                >
                                                    <div
                                                        className={`condition ${
                                                            data.auctionnotes === 'New' ||
                                                            data.auctionnotes === 'new'
                                                                ? 'condition_new'
                                                                : data.auctionnotes === 'Used'
                                                                ? 'condition_used'
                                                                : data.auctionnotes === 'Damaged'
                                                                ? 'condition_Damaged'
                                                                : data.auctionnotes === 'test'
                                                                ? 'condition_test'
                                                                : data.auctionnotes === 'Open Box'
                                                                ? 'condition_openbox'
                                                                : data.auctionnotes === 'Open-box'
                                                                ? 'condition_openbox'
                                                                : data.auctionnotes === 'Open-Box'
                                                                ? 'condition_openbox'
                                                                : data.auctionnotes === 'Test'
                                                                ? 'condition_test'
                                                                : data.auctionnotes === 'Like new'
                                                                ? 'condition_likenew'
                                                                : data.auctionnotes ===
                                                                  'Not Inspected'
                                                                ? 'condition_Damaged'
                                                                : data.auctionnotes ===
                                                                  'Uninspected'
                                                                ? 'condition_Damaged'
                                                                : data.auctionnotes === 'Untested'
                                                                ? 'condition_untested'
                                                                : 'condition_combain'
                                                        } mb-2
                                                        `}
                                                    >
                                                        {data.auctionnotes !== ''
                                                            ? data.auctionnotes
                                                            : 'New'}
                                                    </div>
                                                </Tooltip>
                                            </ClickAwayListener>
                                        </>
                                    )}
                                </>
                            )}
                            {!endingItem && isRRProject && card_theme == 'lotsauction' && (
                                <>
                                    {!isBargainsProject && !isBuyBestProject ? (
                                        <>
                                            {auction_city || data.auction_city ? (
                                                <div
                                                    className="grid-loc"
                                                    onClick={() =>
                                                        isVarifiedGfTheme
                                                            ? handleRedirectInternal(
                                                                  history,
                                                                  'locations',
                                                              )
                                                            : handleRedirectInternal(
                                                                  history,
                                                                  'become_a_seller',
                                                              )
                                                    }
                                                >
                                                    <label>
                                                        {!isVarifiedGfTheme ? (
                                                            <>
                                                                Location : {data?.auction_address},
                                                                {auction_city || data.auction_city},{' '}
                                                                {getStateAbbreviation(
                                                                    data.auction_state,
                                                                )}{' '}
                                                                {data?.auction_zipcode}
                                                            </>
                                                        ) : isBuyBestProject ? (
                                                            <>
                                                                Location: 18 Blackjack Road, Suite
                                                                101,
                                                                <br /> Fredericksburg, VA, 22405
                                                            </>
                                                        ) : (
                                                            <>
                                                                Location : 4645 Morse Centre Rd.
                                                                <br /> Columbus, OH 43229
                                                            </>
                                                        )}
                                                    </label>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                            <div className="pickUply">
                                                {data?.localpickup == 1 && data?.hasshipping == 1
                                                    ? ' Pickup and Shipping'
                                                    : data?.localpickup == 1
                                                    ? ' Pickup Only'
                                                    : 'Shipping Only'}
                                            </div>{' '}
                                        </>
                                    ) : null}
                                </>
                            )}
                            {/* Write Optimized code for this and uncomment */}
                            {/* {showLocation ? (
                                    <p className="gpAddnInfo">
                                        Location:{' '}
                                        <span>
                                            {data?.location
                                                ? countryList
                                                      .filter(
                                                          (country) =>
                                                              country.location_id == data.location,
                                                      )
                                                      .map((d) => d.name)
                                                : '--'}
                                        </span>
                                    </p>
                                ) : (
                                    ''
                                )} */}
                        </>
                    )}
                    {cardTheme == 'HeavyEquipment' ? (
                        <div className="gaInfo">
                            {fromSearch ? (
                                <h6>Lot ID: {data.category_id}</h6>
                            ) : (
                                <h6>Auction ID: {data.id}</h6>
                            )}
                            {(data.buynow == 0 && data.auction == 1) ||
                            (data.buynow == 1 && data.auction == 1) ? (
                                <>
                                    <p>
                                        <span>Start Date:</span>
                                        {moment(data.date_added)
                                            .tz('America/New_York')
                                            .format('MMM Do YYYY, h:mm a')}
                                    </p>
                                    <p>
                                        <span>End Date:</span>
                                        {moment(data.date_closed)
                                            .tz('America/New_York')
                                            .format('MMM Do YYYY, h:mm a')}
                                    </p>
                                </>
                            ) : (
                                ''
                            )}
                            <p
                                className="gaDesc"
                                dangerouslySetInnerHTML={{
                                    __html: data.description,
                                }}
                            ></p>
                        </div>
                    ) : cardTheme == 'carAuction' ? (
                        <div className="autoGridInfo mb-3">
                            {type !== 'buynow' && (
                                <h6 className="crncyValue">
                                    <span className="material-icons-outlined">monetization_on</span>
                                    {data.auction &&
                                        data.wprice &&
                                        currencyFormat(
                                            parseFloat(data.wprice).toFixed(2),
                                            currencyType,
                                        )}
                                    <CurrencyConverterFormat amount={data.wprice} />
                                </h6>
                            )}
                            {data.buynow == 1 && type == 'buynow' && (
                                <h6 className="crncyValue">
                                    <span className="material-icons-outlined">monetization_on</span>
                                    {data.buynow &&
                                        data.bprice &&
                                        currencyFormat(
                                            parseFloat(data.bprice).toFixed(2),
                                            currencyType,
                                        )}
                                    <CurrencyConverterFormat amount={data.bprice} />
                                </h6>
                            )}

                            {!noTimer && data.market_status === 'open' && data.auction ? (
                                <div className="timrVlue">
                                    <span className="material-icons-outlined">watch_later</span>
                                    <Timer
                                        date_added={data.date_added}
                                        date_closed={data.date_closed}
                                        withText={1}
                                        endText={'Time left' + ': '}
                                        startText={'Starts in' + ': '}
                                        theme={timerTheme}
                                        audio={audio}
                                    />
                                </div>
                            ) : (
                                <>
                                    {data.buynow === 0 ? (
                                        <span className="closedText">Auction Closed</span>
                                    ) : (
                                        ''
                                    )}
                                </>
                            )}
                        </div>
                    ) : (
                        <>
                            {cardTheme === 'liquidationTwo' ? (
                                <>
                                    {data.retailer_link && data.mprice ? (
                                        <h6 className="galleryPrice rtlrPrice">
                                            <span className="prcLabel">
                                                Retail Price:{' '}
                                                <a
                                                    href={data.retailer_link}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    (Retailer)
                                                </a>
                                            </span>
                                            &nbsp;
                                            <span className="prcTxtVal">
                                                {currencyFormat(
                                                    parseFloat(data.mprice || 0).toFixed(2),
                                                    currencyType,
                                                )}
                                                <CurrencyConverterFormat amount={data.mprice} />
                                            </span>
                                            {/* <span className="prcTxtVal">
                                                </span> */}
                                        </h6>
                                    ) : (
                                        <h6 className="galleryPrice rtlrPrice"></h6>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}

                            {isRRProject &&
                                card_theme == 'lotsauction' &&
                                !isBuyBestProject &&
                                (endingItem ? (
                                    <>
                                        {(data.buynow && data.bprice) ||
                                        (data.auction && data.wprice) ? (
                                            <>
                                                <h6
                                                    className={`${
                                                        !data.buynow
                                                            ? 'galleryPrice homeflashbuyNow'
                                                            : 'galleryPrice homeflashbuyNow'
                                                    }`}
                                                >
                                                    <span style={{ color: '#c1121f' }}>
                                                        {data.market_status === 'sold'
                                                            ? 'Sold'
                                                            : data.auction && data.wprice
                                                            ? data.nobids > 0
                                                                ? 'Current Price'
                                                                : 'Start Price'
                                                            : 'Buy Now'}{' '}
                                                    </span>
                                                    <span
                                                        className="prcTxtVal"
                                                        style={{ color: '#c1121f' }}
                                                    >
                                                        {currencyFormat(
                                                            parseFloat(
                                                                data.auction && data.wprice
                                                                    ? data.wprice
                                                                    : data.bprice,
                                                            ).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.bprice}
                                                        />
                                                        {data.mprice ? (
                                                            <>
                                                                {' '}
                                                                <div
                                                                    className=""
                                                                    style={{ color: 'black' }}
                                                                >
                                                                    <del
                                                                        style={{
                                                                            'text-decoration-color':
                                                                                '#c1121f',
                                                                            'text-decoration-thickness':
                                                                                '2px',
                                                                        }}
                                                                    >
                                                                        &#40;${data.mprice}&#41;
                                                                    </del>
                                                                </div>
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </span>
                                                </h6>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {(data.buynow && data.bprice) ||
                                        (data.auction && data.wprice) ? (
                                            <>
                                                <h6
                                                    className={`${
                                                        !data.buynow
                                                            ? 'galleryPrice homeflashbuyNow'
                                                            : 'galleryPrice homeflashbuyNow'
                                                    }`}
                                                >
                                                    <span>
                                                        {data.market_status === 'sold'
                                                            ? 'Sold'
                                                            : data.auction && data.wprice
                                                            ? data.nobids > 0
                                                                ? 'Current Price'
                                                                : 'Start Price'
                                                            : 'Buy Now'}{' '}
                                                    </span>
                                                    <span className="prcTxtVal">
                                                        {currencyFormat(
                                                            parseFloat(
                                                                data.auction && data.wprice
                                                                    ? data.wprice
                                                                    : data.bprice,
                                                            ).toFixed(2),
                                                            currencyType,
                                                        )}
                                                        <CurrencyConverterFormat
                                                            amount={data.bprice}
                                                        />
                                                        {data.auction == 1 ? (
                                                            wdiscount > 0 ? (
                                                                <>
                                                                    {' '}
                                                                    <div className="offer">
                                                                        &#40;
                                                                        <del
                                                                            style={{
                                                                                'text-decoration-color':
                                                                                    '#c1121f',
                                                                                'text-decoration-thickness':
                                                                                    '2px',
                                                                            }}
                                                                        >
                                                                            {currencyFormat(
                                                                                parseFloat(
                                                                                    data.mprice,
                                                                                ).toFixed(2),
                                                                                currencyType,
                                                                            )}
                                                                        </del>
                                                                        &#41;
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                ''
                                                            )
                                                        ) : discount > 0 &&
                                                          (data?.bprice || !data?.wprice) ? (
                                                            <>
                                                                {' '}
                                                                &#40;
                                                                <div className="offer">
                                                                    <del
                                                                        style={{
                                                                            'text-decoration-color':
                                                                                '#c1121f',
                                                                            'text-decoration-thickness':
                                                                                '2px',
                                                                        }}
                                                                    >
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                data.mprice,
                                                                            ).toFixed(2),
                                                                            currencyType,
                                                                        )}
                                                                    </del>{' '}
                                                                </div>
                                                                &#41;
                                                            </>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </span>
                                                </h6>
                                                {!endingItem ? (
                                                    <small className="retaileraprice">
                                                        Retail Value ${data.mprice}
                                                    </small>
                                                ) : null}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                ))}

                            {isRRProject && card_theme == 'lotsauction' ? null : (
                                <>
                                    {type !== 'buynow' && (
                                        // parseInt(global.storeConfigration.length) > 0 ?
                                        // (!!Number(global.storeConfigration[2].value) ||
                                        //     !!Number(global.storeConfigration[3].value)) && (
                                        <h6 className="galleryPrice actnPriceVlue nowrap d-flex">
                                            {(data.auction && data.wprice) ||
                                            fromComponent == 'home' ? (
                                                <>
                                                    {data.market_status == 'closed' ? (
                                                        <span>UnSold</span>
                                                    ) : (
                                                        <>
                                                            {global.pluginConfiguration
                                                                ?.reverse_auction?.enable &&
                                                            parseInt(data.content_head5) == 1 ? (
                                                                <span>
                                                                    {data.market_status == 'sold'
                                                                        ? 'Sold'
                                                                        : 'Current'}{' '}
                                                                    Bid:{' '}
                                                                </span>
                                                            ) : (
                                                                <span>
                                                                    {data.market_status == 'sold'
                                                                        ? data.nobids ||
                                                                          fromComponent == 'home'
                                                                            ? 'Sold'
                                                                            : 'Start'
                                                                        : data.nobids ||
                                                                          data.bid_count
                                                                        ? 'Current'
                                                                        : 'Current'}{' '}
                                                                    Bid:{' '}
                                                                </span>
                                                            )}
                                                            <span className="d-flex align-items-center">
                                                                {fromComponent == 'home' ? (
                                                                    <span className="prcTxtVal">
                                                                        {/* <div>{result}%</div> */}
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                data.wprice
                                                                                    ? data.wprice
                                                                                    : data.bprice,
                                                                            ).toFixed(2),
                                                                            currencyType,
                                                                        )}
                                                                        <CurrencyConverterFormat
                                                                            amount={data.wprice}
                                                                        />
                                                                    </span>
                                                                ) : (
                                                                    <span className="prcTxtVal">
                                                                        {/* <div>{result}%</div> */}
                                                                        {currencyFormat(
                                                                            parseFloat(
                                                                                data.wprice,
                                                                            ).toFixed(2),
                                                                            currencyType,
                                                                        )}
                                                                        <CurrencyConverterFormat
                                                                            amount={data.wprice}
                                                                        />
                                                                    </span>
                                                                )}
                                                                {/* <span className="prcTxtVal">
                                                                </span> */}
                                                                {cardTheme === 'liquidationTwo' && (
                                                                    <>
                                                                        {/* {global?.storeConfigration
                                                                        ?.view_bid_history
                                                                        ?.value ? null : ( */}
                                                                        <>
                                                                            &nbsp; |{' '}
                                                                            {data.nobids ||
                                                                                data.bid_count ||
                                                                                0}{' '}
                                                                            Bids
                                                                        </>
                                                                        {/* )} */}
                                                                    </>
                                                                )}
                                                            </span>
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {' '}
                                                    {data.market_status == 'closed' ? (
                                                        <span>UnSold</span>
                                                    ) : (
                                                        <>
                                                            {data.auction ? (
                                                                <span className="crncyNtAvlblVlue">
                                                                    <span>
                                                                        {data.market_status ==
                                                                        'sold'
                                                                            ? 'Sold'
                                                                            : parseInt(
                                                                                  data.wprice,
                                                                              ) ===
                                                                              parseInt(data.sprice)
                                                                            ? 'Current'
                                                                            : 'Current'}
                                                                        Bid:
                                                                    </span>
                                                                    {data.buynow && data.bprice ? (
                                                                        <span className="prcTxtVal">
                                                                            {currencyFormat(
                                                                                parseFloat(
                                                                                    data.bprice,
                                                                                ).toFixed(2),
                                                                                currencyType,
                                                                            )}
                                                                            <CurrencyConverterFormat
                                                                                amount={data.bprice}
                                                                            />
                                                                        </span>
                                                                    ) : (
                                                                        <span className="gridNotAvailable">
                                                                            Not Available
                                                                        </span>
                                                                    )}
                                                                </span>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </h6>
                                    )}
                                    {data.next_bid ? (
                                        <h6 className="galleryPrice actnPriceVlue nowrap d-flex">
                                            <span>Min Bid: </span>
                                            <span className="d-flex align-items-center">
                                                <span className="prcTxtVal">
                                                    {data.next_bid
                                                        ? currencyFormat(
                                                              parseFloat(data.next_bid).toFixed(2),
                                                              currencyType,
                                                          )
                                                        : currencyFormat(
                                                              parseFloat(data.wprice).toFixed(2),
                                                              currencyType,
                                                          )}
                                                </span>
                                            </span>
                                        </h6>
                                    ) : (
                                        ''
                                    )}
                                    {data.incrementamt ? (
                                        <h6 className="galleryPrice actnPriceVlue nowrap d-flex">
                                            <span>Minimum Bid: </span>
                                            <span className="d-flex align-items-center">
                                                <span className="prcTxtVal">
                                                    {currencyFormat(
                                                        parseFloat(data.incrementamt).toFixed(2),
                                                        currencyType,
                                                    )}
                                                </span>
                                            </span>
                                        </h6>
                                    ) : (
                                        ''
                                    )}
                                    <h6 className="galleryPrice actnPriceVlue nowrap d-flex">
                                        <span>MSRP: </span>
                                        <span className="d-flex align-items-center">
                                            <span className="prcTxtVal">
                                                {currencyFormat(
                                                    parseFloat(data.mprice).toFixed(2),
                                                    currencyType,
                                                )}
                                            </span>
                                        </span>
                                    </h6>
                                </>
                            )}

                            {isRRProject && card_theme == 'lotsauction'
                                ? null
                                : global.storeDetails?.theme === 19 && (
                                      <>
                                          {(data.market_status === 'open' && data.auction) ||
                                          data.market_status === 'open' ? (
                                              <Timer
                                                  date_added={data.date_added}
                                                  date_closed={data.date_closed}
                                                  withText={1}
                                                  endText={'Time Remaining' + ': '}
                                                  startText={'Starts in' + ': '}
                                                  theme={timerTheme}
                                                  iconGrid={timerIcon}
                                                  audio={audio}
                                              />
                                          ) : (
                                              <>
                                                  {data.buynow === 0 ? (
                                                      <div className="closedText">
                                                          Auction Closed
                                                      </div>
                                                  ) : (
                                                      <div className="closedText"></div>
                                                  )}
                                              </>
                                          )}
                                      </>
                                  )}

                            {global.storeDetails?.theme === 18 && (
                                <>
                                    <div className="d-flex align-items-center justify-content-between">
                                        {isAuthenticated && (
                                            <span>
                                                {global?.storeConfigration?.view_bid_history
                                                    ?.value ? (
                                                    <>
                                                        &nbsp;
                                                        {data.nobids || data.bid_count || 0} Bids
                                                    </>
                                                ) : null}
                                            </span>
                                        )}
                                        {!noTimer && data.date_closed && (
                                            <div
                                                className={`gcTimer primeTmCrd  ${
                                                    data.buynow === 1 && data.auction === 0
                                                        ? 'noBackDrop'
                                                        : ''
                                                } ${
                                                    isAuthenticated &&
                                                    global.storeDetails?.theme === 18 &&
                                                    'noTimeLeft'
                                                }`}
                                            >
                                                {/*eslint-disable*/}
                                                {(data.market_status === 'open' && data.auction) ||
                                                (data.market_status === 'open' &&
                                                    auction_and_buynow) ? (
                                                    <Timer
                                                        date_added={data.date_added}
                                                        date_closed={data.date_closed}
                                                        withText={1}
                                                        endText={'Time left' + ': '}
                                                        startText={'Starts in' + ': '}
                                                        theme={timerTheme}
                                                        icon={timerIcon}
                                                        audio={audio}
                                                    />
                                                ) : (
                                                    <>
                                                        {data.buynow === 0 ? (
                                                            <span className="closedText">
                                                                Auction Closed
                                                            </span>
                                                        ) : (
                                                            <div className="closedText"></div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}

                            {global.storeConfigration?.show_condition?.value == 1 &&
                            cardTheme == 'liquidationTwo' ? (
                                <h6 className="galleryPrice condition">
                                    <span>Condition: </span>
                                    <span
                                        className={`prcTxtVal ${
                                            data.auctionnotes
                                                ?.trim()
                                                ?.toLowerCase()
                                                ?.includes('new')
                                                ? 'badge badge-success text-white'
                                                : data.auctionnotes
                                                      ?.trim()
                                                      ?.toLowerCase()
                                                      ?.includes('open box')
                                                ? 'badge badge-primary text-white'
                                                : data.auctionnotes
                                                      ?.trim()
                                                      ?.toLowerCase()
                                                      ?.includes('damage')
                                                ? 'badge badge-danger text-white'
                                                : ''
                                        }`}
                                        title={data.auctionnotes ? data.auctionnotes : '-'}
                                    >
                                        {data.auctionnotes ? data.auctionnotes : '-'}
                                    </span>
                                </h6>
                            ) : null}

                            {global.storeConfigration?.show_warehouse_location?.value == 1 ? (
                                <h6 className="galleryPrice condition">
                                    <span>Location: </span>
                                    <span
                                        className="prcTxtVal"
                                        title={data.location ? data.location : '-'}
                                    >
                                        {data.location ? data.location : '-'}
                                    </span>
                                </h6>
                            ) : null}

                            {global?.storeConfigration?.need_transferable?.value == 1 ? (
                                <h6
                                    className="galleryPrice condition"
                                    style={{ display: 'flex', justifyContent: 'space-between' }}
                                >
                                    <span style={{ display: 'flex' }}>
                                        Transferable:
                                        {data.transferable ? (
                                            <Tooltip
                                                title={
                                                    data.transferable == 'Yes'
                                                        ? 'This item can be transfered to a different warehouse location for pickup.'
                                                        : data.transferable == 'No'
                                                        ? 'This item must be picked up from its original location.'
                                                        : ''
                                                }
                                                arrow
                                                placement="top-start"
                                                open={showTooltip}
                                                onOpen={() => setShowTooltip(true)}
                                                onClose={() => setShowTooltip(false)}
                                                className="tooling"
                                                style={{ marginLeft: '5px' }}
                                            >
                                                <span onClick={() => setShowTooltip(!showTooltip)}>
                                                    i
                                                </span>
                                            </Tooltip>
                                        ) : (
                                            ''
                                        )}
                                    </span>
                                    <span
                                        className="prcTxtVal"
                                        title={data.transferable ? data.transferable : '-'}
                                    >
                                        {data.transferable ? data.transferable : '-'}
                                    </span>
                                </h6>
                            ) : null}

                            {isRRProject && card_theme == 'lotsauction' ? (
                                <>
                                    {!noBuyNow &&
                                        type !== 'auction' &&
                                        cardTheme !== 'auctioneer' &&
                                        (data.buynow && data.bprice ? (
                                            <h6
                                                className={`${
                                                    !data.buynow ? 'noPrice' : 'galleryPrice btmBox'
                                                }`}
                                            >
                                                <span>
                                                    {data.market_status === 'sold'
                                                        ? 'Sold'
                                                        : 'Buy Now'}{' '}
                                                    Price:{' '}
                                                </span>
                                                &nbsp;
                                                <span className="prcTxtVal">
                                                    {currencyFormat(
                                                        parseFloat(data.bprice).toFixed(2),
                                                        currencyType,
                                                    )}
                                                    <CurrencyConverterFormat amount={data.bprice} />
                                                </span>
                                                {/* <span className="prcTxtVal">
                                                    </span> */}
                                            </h6>
                                        ) : (
                                            <></>
                                        ))}
                                </>
                            ) : (
                                <>
                                    {!noBuyNow &&
                                        type !== 'auction' &&
                                        cardTheme !== 'auctioneer' &&
                                        (data.buynow && data.bprice ? (
                                            <h6
                                                className={`${
                                                    !data.buynow ? 'noPrice' : 'galleryPrice'
                                                }`}
                                            >
                                                <span>
                                                    {data.market_status === 'sold'
                                                        ? 'Sold'
                                                        : 'Buy Now'}{' '}
                                                    Price:{' '}
                                                </span>
                                                &nbsp;
                                                <span className="prcTxtVal">
                                                    {currencyFormat(
                                                        parseFloat(data.bprice).toFixed(2),
                                                        currencyType,
                                                    )}
                                                    <CurrencyConverterFormat amount={data.bprice} />
                                                </span>
                                                {/* <span className="prcTxtVal">
                                                    </span> */}
                                            </h6>
                                        ) : (
                                            <></>
                                        ))}
                                </>
                            )}

                            {!noBuyNow && type !== 'auction' && cardTheme == 'auctioneer' && (
                                <>
                                    {data.buynow && data.bprice ? (
                                        <div className="d-flex justify-content-between align-items-center mb-4 mt-3">
                                            <div className="price-currency">
                                                <div className="pro-price">
                                                    {currencyFormat(data.bprice)}
                                                </div>
                                                <CurrencyConverterFormat amount={data.bprice} />
                                                <div className="pro-price-label">
                                                    +{' '}
                                                    {data.hasshipping ? 'Shipping' : 'Local Pickup'}
                                                </div>
                                            </div>
                                            <div className="pro-price-label">
                                                {/* <p>2 years warranty</p>
                                                    <p>Add-ons available</p> */}
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            )}
                        </>
                    )}

                    {!endingItem ? (
                        <div className="availableRetailQty">
                            {global?.storeConfigration?.buy_now_with_qty?.value == 1 ? (
                                data.buynow &&
                                data.bprice &&
                                data.category_id !=
                                    global?.storeConfigration?.similar_category?.value ? (
                                    <h6
                                        // style={{ minHeight: '23px', height: '100%' }}
                                        className={`${!data.buynow ? 'noPrice' : ''} `}
                                    >
                                        <span>Available Qty: </span>
                                        &nbsp;
                                        <span className="prcTxtVal">{data.qty}</span>
                                    </h6>
                                ) : (
                                    <></>
                                )
                            ) : (
                                ''
                            )}
                        </div>
                    ) : null}

                    {lotBidding ? (
                        lotBidding
                    ) : data.date_closed &&
                      moment(data.date_closed).isValid() &&
                      auctionTimer &&
                      moment(auctionTimer).isValid() &&
                      new Date(data.date_closed).getTime() - new Date(auctionTimer).getTime() < 0 &&
                      !data.buynow ? (
                        <p> </p>
                    ) : data?.user_id == user?.id && data.market_status == 'open' ? (
                        <p className="cntBidOwn" style={{ whiteSpace: 'nowrap' }}>
                            {data.buynow
                                ? 'You cannot buy your own product!'
                                : 'You cannot bid on your own product!'}
                        </p>
                    ) : (
                        <>
                            {cardTheme == 'auctioneer' ||
                            cardTheme == 'liquidationTwo' ||
                            cardTheme == 'carAuction' ? (
                                data.auction &&
                                !window.location.pathname.includes('gallery') &&
                                type !== 'buynow' ? (
                                    <>
                                        <div
                                            className={`gpBidCart ${
                                                cardTheme === 'carAuction' ? 'carAucBid' : ''
                                            }`}
                                        >
                                            <Bidding
                                                theme="multiseller"
                                                data={data}
                                                hard={
                                                    global.storeConfigration?.hard_bid?.value || '1'
                                                }
                                                shortText={bidBtnLabel}
                                                removePopup={removePopup}
                                            />
                                            {cardTheme !== 'carAuction' ? (
                                                <>
                                                    {type == 'buynow' && type != 'Auction'
                                                        ? ''
                                                        : isAuthenticated &&
                                                          cardTheme != 'liquidationTwo' &&
                                                          ((parseInt(data.buynow) == 1 &&
                                                              parseInt(data.auction) == 0) ||
                                                              (parseInt(data.wprice) <=
                                                                  parseInt(data.bprice) &&
                                                                  parseInt(data.buynow) == 1 &&
                                                                  parseInt(data.auction) == 1)) &&
                                                          data.market_status == 'open' && (
                                                              <Button
                                                                  className={`cartBtn ${
                                                                      active ? 'active' : ''
                                                                  }`}
                                                                  onClick={() =>
                                                                      handleCart(data.id, 1)
                                                                  }
                                                                  disabled={data.buynow == 0}
                                                              >
                                                                  <span className="material-icons-outlined">
                                                                      {active
                                                                          ? 'shopping_cart_checkout'
                                                                          : 'add_shopping_cart'}
                                                                  </span>
                                                              </Button>
                                                          )}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        {cardTheme == 'liquidationTwo' ? (
                                            <>
                                                {type == 'buynow' && type != 'Auction' ? (
                                                    <div className={`gpBidCart spByNw`}></div>
                                                ) : ((parseInt(data.buynow) == 1 &&
                                                      parseInt(data.auction) == 0) ||
                                                      (parseInt(data.wprice) <=
                                                          parseInt(data.bprice) &&
                                                          parseInt(data.buynow) == 1 &&
                                                          parseInt(data.auction) == 1)) &&
                                                  data.market_status == 'open' ? (
                                                    <div className="gpBidCart spByNw">
                                                        {isAuthenticated ? (
                                                            <PrimaryButton
                                                                btnSize={'small'}
                                                                onClick={() =>
                                                                    handleCart(data.id, 1)
                                                                }
                                                                disabled={data.buynow == 0}
                                                                label={
                                                                    active === true
                                                                        ? 'Added to Cart'
                                                                        : cardTheme !== 'auctioneer'
                                                                        ? `Buy it Now: ${currencyFormat(
                                                                              data.bprice,
                                                                          )}`
                                                                        : 'Add to Cart'
                                                                }
                                                            />
                                                        ) : (
                                                            <PrimaryButton
                                                                btnSize={'small'}
                                                                onClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        'login',
                                                                    )
                                                                }
                                                                disabled={data.buynow == 0}
                                                                label={`Login To Buy: ${currencyFormat(
                                                                    data.bprice,
                                                                )}`}
                                                            />
                                                        )}
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </>
                                ) : data.market_status !== 'sold' ? (
                                    <>
                                        {cardTheme === 'liquidationTwo' &&
                                            type == 'buynow' &&
                                            type != 'Auction' && (
                                                <div className="noBidAboveDiv"></div>
                                            )}
                                        {isAuthenticated ||
                                        global?.storeConfigration?.guest_user_login?.value ? (
                                            <PrimaryButton
                                                btnSize={
                                                    cardTheme === 'liquidationTwo' ? 'small' : ''
                                                }
                                                onClick={() => handleCart(data.id, 1)}
                                            >
                                                {active === true
                                                    ? 'Added to Cart'
                                                    : cardTheme !== 'auctioneer'
                                                    ? `Buy it Now: ${currencyFormat(data.bprice)}`
                                                    : 'Add to Cart'}
                                            </PrimaryButton>
                                        ) : (
                                            <PrimaryButton
                                                btnSize={
                                                    cardTheme === 'liquidationTwo' ? 'small' : ''
                                                }
                                                onClick={() =>
                                                    handleRedirectInternal(history, 'login')
                                                }
                                            >
                                                {`Login To Buy: ${currencyFormat(data.bprice)}`}
                                            </PrimaryButton>
                                        )}
                                        {cardTheme === 'liquidationTwo' &&
                                            type == 'buynow' &&
                                            type != 'Auction' && (
                                                <div className="text-center endDteTxt noBidDownDiv"></div>
                                            )}

                                        {/* {!isAuthenticated && (
                                                <>
                                                    {cardTheme === 'liquidationTwo' &&
                                                        type == 'buynow' &&
                                                        type != 'Auction' && (
                                                            <div className="noBidDiv"></div>
                                                        )}
                                                </>
                                            )} */}
                                    </>
                                ) : null
                            ) : cardTheme == 'multiseller' || cardTheme == 'fundRaiser' ? (
                                data.auction && !window.location.pathname.includes('gallery') ? (
                                    data.date_closed &&
                                    (global.pluginConfiguration?.reverse_auction?.enable ? (
                                        <Biddingforwardandreverse
                                            theme="multiseller"
                                            data={data}
                                            hard="1"
                                            shortText={bidBtnLabel}
                                            is_registered={is_registered}
                                            private_auction={private_auction}
                                        />
                                    ) : (
                                        <Bidding
                                            theme="multiseller"
                                            data={data}
                                            hard={global.storeConfigration?.hard_bid?.value || '1'}
                                            shortText={bidBtnLabel}
                                            removePopup={removePopup}
                                        />
                                    ))
                                ) : data.market_status !== 'sold' ? (
                                    <PrimaryButton
                                        onClick={() =>
                                            isAuthenticated
                                                ? productViewLink
                                                    ? history.push({
                                                          pathname: productViewLink,
                                                      })
                                                    : handleClick(data.id)
                                                : handleRedirectInternal(history, 'login')
                                        }
                                    >
                                        {isAuthenticated ? 'Buy Now' : 'Login To Buy'}
                                    </PrimaryButton>
                                ) : null
                            ) : cardTheme == 'HeavyEquipment' ? (
                                <div className="gaCTA">
                                    <PrimaryButton
                                        onClick={() =>
                                            productViewLink
                                                ? history.push({
                                                      pathname: productViewLink,
                                                  })
                                                : handleClick(data.id)
                                        }
                                    >
                                        View Details
                                    </PrimaryButton>
                                    <AddToCalendar data={data} />
                                </div>
                            ) : global?.storeConfigration?.qty_input_slider?.value == 1 &&
                              data.buynow ? (
                                ''
                            ) : new Date(data.date_added) > new Date() &&
                              data.content_head5 == 1 &&
                              global.pluginConfiguration?.reverse_auction?.enable &&
                              !data?.make_an_offer_io ? (
                                <p>Wait until auction starts!</p>
                            ) : isBuyBestProject ? null : (
                                <div className="timer-text mt-2"></div>
                            )}
                        </>
                    )}
                    {global?.storeConfigration?.qty_input_slider?.value == 1 && data.buynow ? (
                        <>
                            <div className="newAdded">
                                <Qtyinputcard
                                    total_qty={data.qty}
                                    qty={'1'}
                                    product_id={data.id}
                                    disabled={active}
                                    isAuthenticated={isAuthenticated}
                                    history={history}
                                />
                                {data.market_status == 'open' && (
                                    <FavouriteCheckbox
                                        watchlisted={
                                            data.watchlistid ||
                                            data.watchlisted ||
                                            data.isFav ||
                                            data.watch
                                        }
                                        project_id={data.id}
                                        getAllProducts={getAllProducts}
                                        data={data}
                                        from={'card'}
                                        viewProduct={viewProduct}
                                        setViewProduct={setViewProduct}
                                    />
                                )}
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                </>
            </div>
            {isRRProject ? null : (
                <>
                    {!noBidButton && link && fromComponent != 'home' && (
                        <>
                            {data.id !== undefined ? (
                                type !== 'buynow' && (
                                    <>
                                        {}
                                        <div
                                            className={`${
                                                isAuthenticated && 'gridItemAct bid-now-wrap'
                                            }`}
                                        >
                                            {data.auction &&
                                            isAuthenticated &&
                                            global.storeDetails?.theme == 19 ? (
                                                <>
                                                    {global.storeConfigration?.hard_bid?.value ==
                                                        '1' &&
                                                        (hideQuickBid === undefined ||
                                                            !hideQuickBid) && (
                                                            <div
                                                                className={
                                                                    isLOAProject
                                                                        ? `lots-bidding-view mt-2 bidGroupBtn`
                                                                        : `lots-bidding-view mt-2`
                                                                }
                                                            >
                                                                <Bidding
                                                                    data={data}
                                                                    hard="0"
                                                                    shortText="Submit Bid"
                                                                    // enableNextBid={true}
                                                                    // nextbidText={`Proxy Bid ${
                                                                    //     data?.next_bid
                                                                    //         ? currencyFormat(
                                                                    //               parseFloat(
                                                                    //                   data?.next_bid
                                                                    //                       ? data?.next_bid
                                                                    //                       : 0,
                                                                    //               ).toFixed(2),
                                                                    //           )
                                                                    //         : ''
                                                                    // }`}
                                                                    // hideBid={true}
                                                                    // removePopup={false}
                                                                />
                                                            </div>
                                                        )}
                                                </>
                                            ) : (
                                                <PrimaryButton
                                                    name={data.id}
                                                    onClick={() =>
                                                        isAuthenticated
                                                            ? productViewLink
                                                                ? history.push({
                                                                      pathname: productViewLink,
                                                                  })
                                                                : handleClick(data.id)
                                                            : handleRedirectInternal(
                                                                  history,
                                                                  'login',
                                                              )
                                                    }
                                                    label={
                                                        window.location.pathname.includes(
                                                            'search',
                                                        ) ||
                                                        type === 'Auction' ||
                                                        data.auction
                                                            ? (type === 'buynow' || data.buynow) &&
                                                              (!data.auction ||
                                                                  window.location.href.includes(
                                                                      '/gallery',
                                                                  ))
                                                                ? isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                                : isAuthenticated
                                                                ? 'Bid Now'
                                                                : 'Login To Bid'
                                                            : isAuthenticated
                                                            ? 'Buy Now'
                                                            : 'Login To Buy Now'
                                                    }
                                                    btnColor={
                                                        data.latestbid_user == user?.id && 'success'
                                                    }
                                                />
                                            )}

                                            {cardTheme !== 'carAuction' &&
                                            global?.storeConfigration?.qty_input_slider?.value !=
                                                1 &&
                                            data.market_status == 'open' ? (
                                                <>
                                                    {type != 'buynow' && type == 'Auction'
                                                        ? ''
                                                        : isAuthenticated &&
                                                          parseInt(data.wprice) <=
                                                              parseInt(data.bprice) && (
                                                              <Button
                                                                  className={`cartBtn ${
                                                                      active ? 'active' : ''
                                                                  } `}
                                                                  onClick={() =>
                                                                      handleCart(data.id, 1)
                                                                  }
                                                                  disabled={
                                                                      data.buynow == 0 ||
                                                                      user?.status == 'suspended'
                                                                  }
                                                              >
                                                                  <span className="material-icons-outlined">
                                                                      {active
                                                                          ? 'shopping_cart_checkout'
                                                                          : 'add_shopping_cart'}
                                                                  </span>
                                                              </Button>
                                                          )}
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </div>

                                        {data.auction && isAuthenticated ? (
                                            type === 'buynow' && !data.auction ? null : (
                                                <>
                                                    {global.storeConfigration?.hard_bid?.value ==
                                                        '1' &&
                                                        (hideQuickBid === undefined ||
                                                            !hideQuickBid) && (
                                                            <div className="lots-bidding-view mt-2">
                                                                <Bidding
                                                                    data={data}
                                                                    hard="1"
                                                                    shortText="Submit Your Bid"
                                                                    enableNextBid={true}
                                                                    nextbidText={`Quick Bid ${
                                                                        data?.next_bid
                                                                            ? currencyFormat(
                                                                                  parseFloat(
                                                                                      data?.next_bid
                                                                                          ? data?.next_bid
                                                                                          : 0,
                                                                                  ).toFixed(2),
                                                                              )
                                                                            : ''
                                                                    }`}
                                                                    hideBid={true}
                                                                    removePopup={false}
                                                                />
                                                            </div>
                                                        )}
                                                </>
                                            )
                                        ) : null}
                                    </>
                                )
                            ) : (
                                <></>
                            )}
                        </>
                    )}
                </>
            )}
            {isRRProject ? (
                <>
                    {isBuyBestProject && fromComponent === 'home' ? null : (
                        <div
                            className={`homeflashBtnGroup ${!isAuthenticated && 'noAuth'} ${
                                data.auction && !data.buynow && 'aucBox'
                            } ${data.bprice < data.wprice && 'buyLessWin'} ${
                                !data.auction && data.buynow && 'buyBox'
                            }`}
                        >
                            {data.auction && !data.buynow ? (
                                <>
                                    {isAuthenticated ? (
                                        isRRProject && data.market_status !== 'open' ? null : (
                                            <PrimaryButton
                                                btnSize="homeBidBtn"
                                                disabled={data.market_status !== 'open'}
                                                onClick={() => handleBidModalClick(data.id)}
                                                label="Bid Now"
                                            />
                                        )
                                    ) : (
                                        <PrimaryButton
                                            btnSize="homeBidBtn"
                                            disabled={data.market_status !== 'open'}
                                            onClick={() => {
                                                localStorage.setItem(
                                                    'routeTo',
                                                    JSON.stringify(data.id),
                                                )
                                                handleRedirectInternal(history, 'login')
                                            }}
                                            label="Login To Bid"
                                        />
                                    )}
                                </>
                            ) : data.auction && data.buynow ? (
                                <>
                                    {isAuthenticated ? (
                                        isRRProject && data.market_status !== 'open' ? null : (
                                            <>
                                                <PrimaryButton
                                                    btnSize="homeBidBtn"
                                                    disabled={data.market_status !== 'open'}
                                                    onClick={() => handleBidModalClick(data.id)}
                                                    label="Bid Now"
                                                />
                                                {data.bprice > data.wprice ? (
                                                    <PrimaryButton
                                                        btnSize="homeBuyBtn"
                                                        disabled={data.market_status !== 'open'}
                                                        name={data.id}
                                                        onClick={() =>
                                                            // productViewLink
                                                            //     ? history.push({
                                                            //           pathname: productViewLink,
                                                            //       })
                                                            //     : handleClick(data.id)
                                                            handleCart(data.id, 1)
                                                        }
                                                        label={
                                                            window.location.pathname.includes(
                                                                'search',
                                                            ) ||
                                                            type === 'Auction' ||
                                                            data.auction
                                                                ? (type === 'buynow' ||
                                                                      data.buynow) &&
                                                                  (!data.auction ||
                                                                      window.location.href.includes(
                                                                          '/gallery',
                                                                      ))
                                                                    ? isAuthenticated
                                                                        ? 'Buy Now'
                                                                        : 'Login To Buy Now'
                                                                    : isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Bid'
                                                                : isAuthenticated
                                                                ? 'Buy Now'
                                                                : 'Login To Buy Now'
                                                        }
                                                        btnColor={
                                                            data.latestbid_user == user?.id &&
                                                            'success'
                                                        }
                                                    />
                                                ) : null}
                                            </>
                                        )
                                    ) : (
                                        <PrimaryButton
                                            btnSize="homeBidBtn"
                                            disabled={data.market_status == 'sold'}
                                            onClick={() => {
                                                localStorage.setItem(
                                                    'routeTo',
                                                    JSON.stringify(data.id),
                                                )
                                                handleRedirectInternal(history, 'login')
                                            }}
                                            label="Login To Bid"
                                        />
                                    )}
                                </>
                            ) : !data.auction && data.buynow ? (
                                <>
                                    {isAuthenticated ? (
                                        isRRProject && data.market_status !== 'open' ? null : (
                                            <>
                                                <div className="opacity-0"></div>
                                                <PrimaryButton
                                                    btnSize="homeBuyBtn"
                                                    disabled={data.market_status !== 'open'}
                                                    name={data.id}
                                                    onClick={() =>
                                                        // productViewLink
                                                        //     ? history.push({
                                                        //           pathname: productViewLink,
                                                        //       })
                                                        //     : handleClick(data.id)
                                                        handleCart(data.id, 1)
                                                    }
                                                    label={
                                                        window.location.pathname.includes(
                                                            'search',
                                                        ) ||
                                                        type === 'Auction' ||
                                                        data.auction
                                                            ? (type === 'buynow' || data.buynow) &&
                                                              (!data.auction ||
                                                                  window.location.href.includes(
                                                                      '/gallery',
                                                                  ))
                                                                ? isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                                : isAuthenticated
                                                                ? bidText
                                                                : 'Login To Bid'
                                                            : isAuthenticated
                                                            ? 'Buy Now'
                                                            : 'Login To Buy Now'
                                                    }
                                                    btnColor={
                                                        data.latestbid_user == user?.id && 'success'
                                                    }
                                                />
                                            </>
                                        )
                                    ) : (
                                        <PrimaryButton
                                            btnSize="homeBuyBtn"
                                            disabled={data.market_status !== 'open'}
                                            onClick={() => {
                                                localStorage.setItem(
                                                    'routeTo',
                                                    JSON.stringify(data.id),
                                                )
                                                handleRedirectInternal(history, 'login')
                                            }}
                                            label="Login To Buy"
                                        />
                                    )}
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    )}
                </>
            ) : null}
            {isRRProject && card_theme == 'lotsauction' ? null : (
                <>
                    {!noBidButton && link && fromComponent != 'home' && (
                        <>
                            {data.id !== undefined &&
                            (!data.auction || window.location.href.includes('/gallery')) ? (
                                <div
                                    className={`${isAuthenticated && 'gridItemAct'}  grid-bid-btns`}
                                >
                                    <PrimaryButton
                                        disabled={data.market_status == 'sold'}
                                        name={data.id}
                                        onClick={() =>
                                            isAuthenticated
                                                ? productViewLink
                                                    ? history.push({
                                                          pathname: productViewLink,
                                                      })
                                                    : handleClick(data.id)
                                                : handleRedirectInternal(history, 'login')
                                        }
                                        label={
                                            window.location.pathname.includes('search') ||
                                            type === 'Auction' ||
                                            data.auction
                                                ? (type === 'buynow' || data.buynow) &&
                                                  (!data.auction ||
                                                      window.location.href.includes('/gallery'))
                                                    ? isAuthenticated
                                                        ? 'Buy Now'
                                                        : 'Login To Buy Now'
                                                    : isAuthenticated
                                                    ? bidText
                                                    : 'Login To Bid'
                                                : isAuthenticated
                                                ? 'Buy Now'
                                                : 'Login To Buy Now'
                                        }
                                        btnColor={data.latestbid_user == user?.id && 'success'}
                                    />

                                    {cardTheme !== 'carAuction' &&
                                    global?.storeConfigration?.qty_input_slider?.value != 1 &&
                                    data.market_status == 'open' ? (
                                        <>
                                            {type != 'buynow' && type == 'Auction'
                                                ? ''
                                                : isAuthenticated &&
                                                  parseInt(data.wprice) <=
                                                      parseInt(data.bprice) && (
                                                      <Button
                                                          className={`cartBtn ${
                                                              active ? 'active' : ''
                                                          } `}
                                                          onClick={() => handleCart(data.id, 1)}
                                                          disabled={
                                                              data.buynow == 0 ||
                                                              user?.status == 'suspended'
                                                          }
                                                      >
                                                          Add to Cart
                                                      </Button>
                                                  )}
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            ) : (
                                <></>
                            )}
                        </>
                    )}
                </>
            )}
            {bidModal !== null && (
                <SlidePanel
                    selectedLot={bidModal}
                    handleClose={handleClose}
                    type={type ? type : ''}
                    getAllProducts={getAllProducts}
                    isRRThemeSlidePanel={true}
                />
            )}
        </div>
    )
}

export default memo(LotProduct)
